import React, { useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import moment from 'moment'

import styles from './styles.module.scss'

import { hideScheduleEditTime } from '../../../store/app/actions'
import { changeShiftTimeline } from '../../../api'

import EditTimeForm from '../EditTimeForm'

const EditTime = () => {
  const dispatch = useDispatch()
  const scheduleEditTime = useSelector(state => state.app.scheduleEditTime)

  const formRef = useRef(null)

  useEffect(() => {
    if (scheduleEditTime.show && formRef.current) {
      formRef.current.setForm({
        start: scheduleEditTime.data.start,
        end: scheduleEditTime.data.end,
      })
    }
  }, [scheduleEditTime.show])

  const handleClickOutside = async (e) => {
    const {start, end} = formRef.current.getForm()

    switch (scheduleEditTime.data.type) {
      case 'schedule_timeline':
        const startDate = moment(scheduleEditTime.data.realStart).format('YYYY-MM-DD')
        const endDate = moment(scheduleEditTime.data.realStart).format('YYYY-MM-DD')

        const updatedStart = moment(`${startDate} ${start}`, 'YYYY-MM-DD HH:mm')
        const updatedEnd = moment(`${endDate} ${end}`, 'YYYY-MM-DD HH:mm')

        if (updatedStart.isAfter(updatedEnd)) {
          updatedEnd.add(1, 'day')
        }

        if (scheduleEditTime.data.realStart === updatedStart.format('YYYY-MM-DD HH:mm:ss') && scheduleEditTime.data.realEnd === updatedEnd.format('YYYY-MM-DD HH:mm:ss')) {
          dispatch(hideScheduleEditTime())
          return
        }
        
        const post = {
          dateTime_start: updatedStart.format('YYYY-MM-DD HH:mm'),
          dateTime_end: updatedEnd.format('YYYY-MM-DD HH:mm'),
          data: scheduleEditTime.data.id,
        }
        await changeShiftTimeline(scheduleEditTime.data.companyId, scheduleEditTime.data.shiftId, post)
        dispatch(hideScheduleEditTime())
        document.dispatchEvent(
          new CustomEvent('eventTimeChanged', {
            detail: {
              id: scheduleEditTime.data.id,
              start: updatedStart.format('YYYY-MM-DD HH:mm'),
              end: updatedEnd.format('YYYY-MM-DD HH:mm'),
            }
          })
        )
        break
      case 'copy_tool':
        dispatch(hideScheduleEditTime())
        document.dispatchEvent(
          new CustomEvent('copyToolTimeChanged', {
            detail: {
              start: start,
              end: end,
            }
          })
        )
        break
      default:
        dispatch(hideScheduleEditTime())
        return
        
    }    
  }

  if (!scheduleEditTime.show) {
    return null
  }

  return (
    <div className={styles.container} onClick={handleClickOutside}>
      <div className={styles.content} onClick={e => e.stopPropagation()} style={{ top: scheduleEditTime.position.top, left: scheduleEditTime.position.left }}>
        <EditTimeForm ref={formRef} />
      </div>
    </div>
  )
}

export default EditTime
